import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ConfigService } from '../../../config/config.service';
import { Widget } from '../../../types/Widget.type';

@Injectable({
  providedIn: 'root'
})
export class WidgetAdminService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  listar() {
    return this.httpClient.get<Widget[]>(`${this.configService.getApiUrl()}/widget`);
  }

  buscar(id: string) {
    return this.httpClient.get<Widget>(`${this.configService.getApiUrl()}/widget/${id}`);
  }

  criar(widget: Widget) {
    return this.httpClient.post<Widget>(`${this.configService.getApiUrl()}/widget`, widget);
  }

  alterar(widget: Widget) {
    return this.httpClient.put<Widget>(`${this.configService.getApiUrl()}/widget`, widget);
  }

  excluir(id: string) {
    return this.httpClient.delete<void>(`${this.configService.getApiUrl()}/widget/${id}`);
  }

  identificadorDisponivel(identificador: string) {
    return this.httpClient
      .get<{ disponivel: boolean }>(`${this.configService.getApiUrl()}/widget/identificador/${encodeURIComponent(identificador)}/disponivel`)
      .pipe(map(r => r.disponivel));
  }

  emUso(id: string) {
    return this.httpClient
      .get<{ quantidadeUsuarios: number }>(`${this.configService.getApiUrl()}/widget/${id}/em-uso`)
      .pipe(map(r => r.quantidadeUsuarios));
  }
}
